module.exports = __webpack_public_path__ + "img/bonteous_slide_2.93b13235.jpg";